import { useFlags } from "launchdarkly-react-client-sdk";

import { NotFound } from "src/pages/not-found";
import { NoContextOutlet } from "src/router";
import { useIsHightouchUser } from "src/utils/is-hightouch-user";

export const LineageInternalGuard = () => {
  const isHightouchUser = useIsHightouchUser();
  const { lineageGraphOnDemand } = useFlags();

  if (!isHightouchUser || !lineageGraphOnDemand) {
    return <NotFound />;
  }

  return <NoContextOutlet />;
};
